import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

export const fromJst = (date: Date | string): Date => {
  return fromZonedTime(date, "Asia/Tokyo");
};

export const formatInJst = (date: Date | string, formatStr = "yyyy-MM-dd HH:mm:ss"): string => {
  return formatInTimeZone(new Date(date), "Asia/Tokyo", formatStr);
};
